
import { translate as t } from "src/i18n";
import { Dropdown, DropdownItem, DropdownProps } from ".";

const filterAllOption: DropdownItem = {
    value: '',
    get label() { return t('common.filter.all'); }
};

export function DropdownFilter(props: DropdownProps<string>) {
    return (
        <Dropdown {...props} allowUnselect={true} items={props.value === '' ? props.items : [...props.items, filterAllOption]} />
    );
}
